import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/copy.svg';
const CopySvg = () => React.createElement(IconSvg, null);
CopySvg.Enhance = () => React.createElement(IconSvg, null);
export default CopySvg;
